import {Product} from "../../../api/Products";
import {useGetAll} from "../../logistics/routes/useGetAll";
import {api} from "../../../api/API";
import {Company, CompanyKind, CompanyListInput} from "../../../api/Companies";
import {DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {SmoothActionBar} from "../../../misc/SmoothActionBar";
import React, {useRef, useState} from "react";
import {first, useAsyncAction} from "nate-react-api-helpers";
import {AutoComplete} from "../../project/shopdrawing/openings/AutoComplete";
import {DistributorDetail} from "../../../api/Hardware";

export function DistributorSelector(props: {
    anchor: any;
    row: Product | Company;
    width: number;
    initialValue: string;
    onCancel(): void;
    onDone(value: Product | Company): Promise<any>;
}) {
    return (
        <DistributorSelectorInner
            name="Distributor"
            value={props.row.defaultDistributor || null}
            onDone={v => {
                return props.onDone(Object.assign({}, props.row, {defaultDistributor: v ? v.id : null}) as any);
            }}
            onCancel={props.onCancel}
        />
    )
}

export function HwDistributorSelector(props: {
    anchor: any;
    row: DistributorDetail;
    width: number;
    initialValue: string;
    onCancel(): void;
    onDone(value: DistributorDetail): Promise<any>;
}) {
    return (
        <DistributorSelectorInner
            name="Distributor"
            value={props.row.distributorOverride || null}
              onDone={v => {
                  return props.onDone(Object.assign({}, props.row, {
                      distributorOverride: v?.id || null,
                      distributorOverrideName: v?.name || null,
                  }) as any);
              }}
              onCancel={props.onCancel}
        />
    )
}

export function DistributorSelectorInner(props: {
    name: string;
    value: number | null
    source?: CompanyListInput["source"];
    onCancel(): void;
    onDone(value: Company | null): Promise<any>;
}) {
    const source = props.source;
    const companies = useGetAll(props => api.companies.list(props), {
        kind: "supplier" as CompanyKind,
        source: source,
    }, [source]);

    const [value, setValue] = useState(props.value);
    const list = companies.asList || [];

    const onDoneRef = useRef(props.onDone);
    onDoneRef.current = props.onDone;

    const update = useAsyncAction(async (input: Company | null) => {
        await onDoneRef.current(input);
    }, [])

    const submit = () => {
        update.callback(list.find(v => v.id === value) || null);
    };

    return (
        <Dialog2 open onClose={props.onCancel} onEnterPress={submit}>
            <DialogTitle>
                {props.name}
            </DialogTitle>
            <DialogContent>
                <div style={{height: 4}} />
                <AutoComplete<Company>
                    label={props.name}
                    value={first(list, l => l.id === value)}
                    onSelect={v => {
                        setValue(v.id);
                    }}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={a => a.name}
                    search={async search => {
                        return list.filter(v => v.name.toLowerCase().indexOf(search.toLowerCase()) === 0);
                    }}
                    fullWidth
                    style={{minWidth: 350}}
                />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onSubmit={submit}
                onCancel={props.onCancel}
                onDestroy={() => update.callback(null)}
                destroyLoading={update.loading}
                destroyName={`Remove ${props.name}`}
                destroyingWord="Removing…"
            />
        </Dialog2>
    )
}